import { useState } from "react";
import emailjs from "@emailjs/browser";

const Contact = () =>{
    const reset ={
        name:'',
        email:'',
        service:'',
        message:'',
    }
    const [recipient,setRecipient] = useState({
        name:'',
        email:'',
        service:'',
        message:'',
    })
    const [successMsg, setSuccessMsg] = useState('');

    const onChange = (e)=>{
        setRecipient({...recipient,[e.target.name]:e.target.value})
    }
    console.log(recipient);
    const sendEmail = (e)=>{

        e.preventDefault();


        emailjs.send('service_z24weam','template_wg3m0qq',recipient, 'ixFbHWIM_wt1D9E5F').then(()=>{
           console.log('Success');
            setSuccessMsg("Email has been send successfully!")
            setRecipient(reset);
           setTimeout(() => {
            setSuccessMsg(" ");
           }, 1500);
        },
        (error)=>{
            console.log('Failed',error);
        })
    }



    return(
        
        <form onSubmit={sendEmail}>
            <p className="emailMsg">{successMsg}</p>
    <label htmlFor="name">Name: <br />
      <input type="text" name='name' placeholder='Victor Tinotenda Mutswinya' onChange={onChange} value={recipient.name}/>
    </label><br />

    <label htmlFor="email">Email: <br />
      <input type="email" name='email' id="user-email" placeholder='vmutswinya@gmail.com' onChange={onChange} value={recipient.email}/>
    </label><br />

    <label htmlFor="service">Service: <br />
    <input type="text" name='service' placeholder='Type Graphic Design, Website or Software' onChange={onChange} value={recipient.service}/>
    </label><br />

    <label htmlFor="message">Message: <br />
      <textarea   name='message' id="user-msg" placeholder='Tell us about your project...' onChange={onChange} value={recipient.message}/>
    </label><br />
    <button>Send Message</button>
  </form>
    )
}
export default Contact;